module.exports = __webpack_public_path__ + "static/img/employement-opportunity.d33e5b0b.jpg";